module.exports = __webpack_public_path__ + "static/media/mobile-log-header.38039acd.png";